var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Button, Colors, FlexBox, Skeleton, useBreakpoint } from '@brg/ui';
import React, { useMemo, useState } from 'react';
import { PageControl, PageNumber } from './styles';
import styled from 'styled-components';
import { RectangularButtonHollow } from '../buttons';
import { LayoutConst } from '../../constants/media';
import useLocalization from '../../hooks/useLocalization';
// export interface PaginationLayoutProps {
//   isLoading?: boolean
//   paging?: ReactNode
//   button?: ReactNode
//   hidden?: boolean
//   disableOffset?: boolean
// }
var PaginationRoot = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 64px !important;\n  margin-bottom: ", ";\n  flex-wrap: wrap;\n  height: 32px;\n  max-height: 32px;\n  flex-flow: row;\n\n  button {\n    height: 32px !important;\n    max-height: 32px;\n    max-width: 171px;\n    // width: 171px;\n    min-width: 101px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n\n  .pagging_item {\n    font-size: 13px;\n    line-height: 16px;\n    font-weight: 400;\n  }\n\n  visibility: ", ";\n\n  @media (max-width: ", "px) {\n    justify-content: space-between;\n  }\n  @media (max-width: ", "px) {\n    justify-content: center;\n    flex-flow: column;\n\n    > div:first-child {\n      margin-bottom: 16px;\n    }\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 70px;\n  }\n"], ["\n  margin-top: 64px !important;\n  margin-bottom: ", ";\n  flex-wrap: wrap;\n  height: 32px;\n  max-height: 32px;\n  flex-flow: row;\n\n  button {\n    height: 32px !important;\n    max-height: 32px;\n    max-width: 171px;\n    // width: 171px;\n    min-width: 101px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n\n  .pagging_item {\n    font-size: 13px;\n    line-height: 16px;\n    font-weight: 400;\n  }\n\n  visibility: ", ";\n\n  @media (max-width: ", "px) {\n    justify-content: space-between;\n  }\n  @media (max-width: ", "px) {\n    justify-content: center;\n    flex-flow: column;\n\n    > div:first-child {\n      margin-bottom: 16px;\n    }\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 70px;\n  }\n"
    /**
     * Layout компонент переключателя страниц
     */
])), function (_a) {
    var disableOffset = _a.disableOffset;
    return (disableOffset ? 0 : '104px');
}, function (p) { return (p.hidden ? 'hidden' : 'visible'); }, LayoutConst.container.m, LayoutConst.container.s, LayoutConst.container.s);
/**
 * Layout компонент переключателя страниц
 */
export var PaginationLayout = function (props) {
    var isLoading = props.isLoading, paging = props.paging, button = props.button, disableOffset = props.disableOffset;
    return (React.createElement(PaginationRoot, { style: { minWidth: 'calc(100% - 20px)' }, gy: 46, width: '100%', justify: 'space-between', align: 'center', disableOffset: disableOffset },
        !isLoading && button,
        isLoading ? (React.createElement(FlexBox, { gx: 8 },
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }))) : (paging)));
};
export var DotsContainer = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  border-radius: 3px;\n  color: ", ";\n  user-select: none;\n"], ["\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  border-radius: 3px;\n  color: ", ";\n  user-select: none;\n"])), Colors.galBlack47);
export var PageInputWrapper = styled(FlexBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  height: 32px !important;\n  max-height: 32px !important;\n  max-width: 65px;\n  width: 65px;\n  background-color: #E7E7E7;\n  border-radius: 3px;\n  margin-right: 8px;\n"], ["\n  position: relative;\n  height: 32px !important;\n  max-height: 32px !important;\n  max-width: 65px;\n  width: 65px;\n  background-color: #E7E7E7;\n  border-radius: 3px;\n  margin-right: 8px;\n"])));
export var PageInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 100%;\n  width: calc(100% / 2);\n  background-color: transparent !important;\n  outline-color: transparent;\n  color: ", ";\n  border: none;\n  text-align: center;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  &:focus {\n    border: none;\n    outline: none;\n  }\n\n  input {\n    text-align: center;\n    border: none !important;\n    background-color: transparent;\n    outline: none;\n    padding: 0 !important;\n  }\n\n  transition: all 0.2s;\n\n  font-size: 13px;\n  line-height: 16px;\n\n  @media (max-width: ", "px) {\n    height: 28px !important;\n    font-size: 13px;\n    input {\n      padding: 0 12px;\n    }\n  }\n"], ["\n  height: 100%;\n  width: calc(100% / 2);\n  background-color: transparent !important;\n  outline-color: transparent;\n  color: ", ";\n  border: none;\n  text-align: center;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  &:focus {\n    border: none;\n    outline: none;\n  }\n\n  input {\n    text-align: center;\n    border: none !important;\n    background-color: transparent;\n    outline: none;\n    padding: 0 !important;\n  }\n\n  transition: all 0.2s;\n\n  font-size: 13px;\n  line-height: 16px;\n\n  @media (max-width: ", "px) {\n    height: 28px !important;\n    font-size: 13px;\n    input {\n      padding: 0 12px;\n    }\n  }\n"])), Colors.galBlack100, LayoutConst.container.m);
var PaggingItemWrapper = styled(FlexBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  @media (max-width: ", "px) {\n    width: 100%;\n    > :not(:first-child) {\n      margin-left: auto;\n    }\n  }\n"], ["\n  @media (max-width: ", "px) {\n    width: 100%;\n    > :not(:first-child) {\n      margin-left: auto;\n    }\n  }\n"])), LayoutConst.container.s);
var PageInputGroup = styled.form(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  color: ", ";\n\n  &:not(:first-child) {\n    margin-top: 0;\n  }\n"], ["\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  color: ", ";\n\n  &:not(:first-child) {\n    margin-top: 0;\n  }\n"
    // export interface PaginationProps {
    //   isLoading?: boolean
    //   page: number
    //   pages: number
    //   onPageChange?: (page: number) => void
    //   isCanLoadMore?: boolean
    //   loadMore?: () => void
    //   showLoadMore?: boolean
    //   hidden?: boolean
    //   disableOffset?: boolean
    // }
])), function (_a) {
    var theme = _a.theme;
    return theme.text.label;
});
// export interface PaginationProps {
//   isLoading?: boolean
//   page: number
//   pages: number
//   onPageChange?: (page: number) => void
//   isCanLoadMore?: boolean
//   loadMore?: () => void
//   showLoadMore?: boolean
//   hidden?: boolean
//   disableOffset?: boolean
// }
var clamp = function (min, value, max) {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
/**
 * Компонент пагинации
 *
 * @param props
 * @returns
 */
export var Pagination = function (props) {
    var isLoading = props.isLoading, page = props.page, onPageChange = props.onPageChange, pages = props.pages, isCanLoadMore = props.isCanLoadMore, showLoadMore = props.showLoadMore, loadMore = props.loadMore;
    // @ts-ignore
    var t = useLocalization().t;
    var isMobile = useBreakpoint(LayoutConst.container.m);
    var backStep = isMobile ? 2 : 5;
    var forwardStep = isMobile ? 2 : 5;
    var _a = useState(page), pageText = _a[0], setPageText = _a[1];
    // Построение индексов массива
    var pagesList = useMemo(function () {
        var arr = Array();
        var startStep = page >= pages - backStep
            ? pages - (backStep + forwardStep + 1)
            : page - backStep;
        var endStep = page <= forwardStep ? backStep + forwardStep + 1 : page + forwardStep;
        var start = clamp(1, startStep, pages);
        var end = clamp(1, endStep, pages);
        for (var i = start; i <= end; i++) {
            arr.push(i);
        }
        return arr;
    }, [page, pages, backStep, forwardStep]);
    var onPageChangeCreate = function (p) { return function () {
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(p);
    }; };
    var showLast = pages - page > backStep;
    var handleTextChange = function (_a) {
        var value = _a.target.value;
        var numericValue = Number(value);
        if (Number.isNaN(numericValue)) {
            return;
        }
        if (numericValue < 1) {
            // setPageText(1) // past value - из-за единицы появлялся баг
            setPageText(0);
        }
        else if (numericValue > pages) {
            setPageText(pages);
        }
        else {
            setPageText(numericValue);
        }
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(pageText);
    };
    // Отрисовка
    return (React.createElement(PaginationLayout, { isLoading: isLoading, disableOffset: props.disableOffset, button: showLoadMore && isCanLoadMore ? (React.createElement(Button.GreyLarge, { onClick: loadMore, style: { width: '100%', color: Colors.galBlack100 } }, t('show_more'))) : null, paging: pages > 1 && (React.createElement(React.Fragment, null,
            React.createElement(PaggingItemWrapper, { gx: 8 },
                page > forwardStep + 1 && (React.createElement(React.Fragment, null,
                    React.createElement(PageControl, { onClick: onPageChangeCreate(1), isBack: true }),
                    React.createElement(DotsContainer, null, "..."))),
                pagesList
                    .filter(function (i) {
                    if (showLast && page < pages - backStep - 1) {
                        return i !== (pagesList === null || pagesList === void 0 ? void 0 : pagesList.length);
                    }
                    return i;
                })
                    .map(function (value, index) { return (React.createElement("div", { key: "pi_".concat(value, "_ ").concat(index), className: 'pagging_item' }, value > 0 ? (React.createElement(PageNumber, { onClick: onPageChangeCreate(value), active: value === page }, value)) : null)); }),
                showLast && (React.createElement(React.Fragment, null, page < pages - backStep - 1 && (React.createElement(React.Fragment, null,
                    React.createElement(DotsContainer, null, "..."),
                    React.createElement(PageNumber, { onClick: onPageChangeCreate(pages), active: false }, pages))))),
                pagesList[forwardStep] > 0 && (React.createElement(PageControl, { onClick: onPageChangeCreate(page + 1), isNext: true }))),
            React.createElement(PageInputGroup, { onSubmit: handleSubmit },
                React.createElement(PageInputWrapper, null,
                    React.createElement(PageInput, { onChange: handleTextChange, value: pageText })),
                React.createElement(RectangularButtonHollow, { disabled: !pageText || pageText > pages, type: 'submit', style: { color: Colors.galBlack100, borderColor: Colors.galBlack31 } }, t('pagination.go_to_page'))))) }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=pagination.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Button, Colors, FlexBox, Skeleton, useBreakpoint } from '@brg/ui';
import React, { useMemo, useState } from 'react';
import { PageControl, PageNumber } from './styles';
import styled from 'styled-components';
import { RectangularButtonHollow } from '../buttons';
import { LayoutConst } from '../../constants/media';
import useLocalization from '../../hooks/useLocalization';
// export interface PaginationLayoutProps {
//   isLoading?: boolean
//   paging?: ReactNode
//   button?: ReactNode
//   hidden?: boolean
//   disableOffset?: boolean
// }
var PaginationRoot = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 64px !important;\n  margin-bottom: ", ";\n  flex-wrap: wrap;\n  height: 32px;\n  max-height: 32px;\n  flex-flow: row;\n\n  button {\n    height: 32px !important;\n    max-height: 32px;\n    max-width: 171px;\n    // width: 171px;\n    min-width: 101px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n\n  .pagging_item {\n    font-size: 13px;\n    line-height: 16px;\n    font-weight: 400;\n  }\n\n  visibility: ", ";\n\n  @media (max-width: ", "px) {\n    justify-content: space-between;\n  }\n  @media (max-width: ", "px) {\n    justify-content: center;\n    flex-flow: column;\n\n    > div:first-child {\n      margin-bottom: 16px;\n    }\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 70px;\n  }\n"], ["\n  margin-top: 64px !important;\n  margin-bottom: ", ";\n  flex-wrap: wrap;\n  height: 32px;\n  max-height: 32px;\n  flex-flow: row;\n\n  button {\n    height: 32px !important;\n    max-height: 32px;\n    max-width: 171px;\n    // width: 171px;\n    min-width: 101px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n\n  .pagging_item {\n    font-size: 13px;\n    line-height: 16px;\n    font-weight: 400;\n  }\n\n  visibility: ", ";\n\n  @media (max-width: ", "px) {\n    justify-content: space-between;\n  }\n  @media (max-width: ", "px) {\n    justify-content: center;\n    flex-flow: column;\n\n    > div:first-child {\n      margin-bottom: 16px;\n    }\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 70px;\n  }\n"
    /**
     * Layout компонент переключателя страниц
     */
])), function (_a) {
    var disableOffset = _a.disableOffset;
    return (disableOffset ? 0 : '104px');
}, function (p) { return (p.hidden ? 'hidden' : 'visible'); }, LayoutConst.container.m, LayoutConst.container.s, LayoutConst.container.s);
/**
 * Layout компонент переключателя страниц
 */
export var PaginationLayout = function (props) {
    var isLoading = props.isLoading, paging = props.paging, button = props.button, disableOffset = props.disableOffset;
    return (React.createElement(PaginationRoot, { style: { minWidth: 'calc(100% - 20px)' }, gy: 46, width: '100%', justify: 'space-between', align: 'center', disableOffset: disableOffset },
        !isLoading && button,
        isLoading ? (React.createElement(FlexBox, { gx: 8 },
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }),
            React.createElement(Skeleton, { width: 32, height: 32 }))) : (paging)));
};
export var DotsContainer = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  border-radius: 3px;\n  color: ", ";\n  user-select: none;\n"], ["\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  border-radius: 3px;\n  color: ", ";\n  user-select: none;\n"])), Colors.galBlack47);
export var PageInputWrapper = styled(FlexBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  height: 32px !important;\n  max-height: 32px !important;\n  max-width: 65px;\n  width: 65px;\n  background-color: #E7E7E7;\n  border-radius: 3px;\n  margin-right: 8px;\n"], ["\n  position: relative;\n  height: 32px !important;\n  max-height: 32px !important;\n  max-width: 65px;\n  width: 65px;\n  background-color: #E7E7E7;\n  border-radius: 3px;\n  margin-right: 8px;\n"])));
export var PageInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 100%;\n  width: calc(100% / 2);\n  background-color: transparent !important;\n  outline-color: transparent;\n  color: ", ";\n  border: none;\n  text-align: center;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  &:focus {\n    border: none;\n    outline: none;\n  }\n\n  input {\n    text-align: center;\n    border: none !important;\n    background-color: transparent;\n    outline: none;\n    padding: 0 !important;\n  }\n\n  transition: all 0.2s;\n\n  font-size: 13px;\n  line-height: 16px;\n\n  @media (max-width: ", "px) {\n    height: 28px !important;\n    font-size: 13px;\n    input {\n      padding: 0 12px;\n    }\n  }\n"], ["\n  height: 100%;\n  width: calc(100% / 2);\n  background-color: transparent !important;\n  outline-color: transparent;\n  color: ", ";\n  border: none;\n  text-align: center;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  &:focus {\n    border: none;\n    outline: none;\n  }\n\n  input {\n    text-align: center;\n    border: none !important;\n    background-color: transparent;\n    outline: none;\n    padding: 0 !important;\n  }\n\n  transition: all 0.2s;\n\n  font-size: 13px;\n  line-height: 16px;\n\n  @media (max-width: ", "px) {\n    height: 28px !important;\n    font-size: 13px;\n    input {\n      padding: 0 12px;\n    }\n  }\n"])), Colors.galBlack100, LayoutConst.container.m);
var PaggingItemWrapper = styled(FlexBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  @media (max-width: ", "px) {\n    width: 100%;\n    > :not(:first-child) {\n      margin-left: auto;\n    }\n  }\n"], ["\n  @media (max-width: ", "px) {\n    width: 100%;\n    > :not(:first-child) {\n      margin-left: auto;\n    }\n  }\n"])), LayoutConst.container.s);
var PageInputGroup = styled.form(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  color: ", ";\n\n  &:not(:first-child) {\n    margin-top: 0;\n  }\n"], ["\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  color: ", ";\n\n  &:not(:first-child) {\n    margin-top: 0;\n  }\n"
    // export interface PaginationProps {
    //   isLoading?: boolean
    //   page: number
    //   pages: number
    //   onPageChange?: (page: number) => void
    //   isCanLoadMore?: boolean
    //   loadMore?: () => void
    //   showLoadMore?: boolean
    //   hidden?: boolean
    //   disableOffset?: boolean
    // }
])), function (_a) {
    var theme = _a.theme;
    return theme.text.label;
});
// export interface PaginationProps {
//   isLoading?: boolean
//   page: number
//   pages: number
//   onPageChange?: (page: number) => void
//   isCanLoadMore?: boolean
//   loadMore?: () => void
//   showLoadMore?: boolean
//   hidden?: boolean
//   disableOffset?: boolean
// }
var clamp = function (min, value, max) {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
/**
 * Компонент пагинации
 *
 * @param props
 * @returns
 */
export var Pagination = function (props) {
    var isLoading = props.isLoading, page = props.page, onPageChange = props.onPageChange, pages = props.pages, isCanLoadMore = props.isCanLoadMore, showLoadMore = props.showLoadMore, loadMore = props.loadMore;
    // @ts-ignore
    var t = useLocalization().t;
    var isMobile = useBreakpoint(LayoutConst.container.m);
    var backStep = isMobile ? 2 : 5;
    var forwardStep = isMobile ? 2 : 5;
    var _a = useState(page), pageText = _a[0], setPageText = _a[1];
    // Построение индексов массива
    var pagesList = useMemo(function () {
        var arr = Array();
        var startStep = page >= pages - backStep
            ? pages - (backStep + forwardStep + 1)
            : page - backStep;
        var endStep = page <= forwardStep ? backStep + forwardStep + 1 : page + forwardStep;
        var start = clamp(1, startStep, pages);
        var end = clamp(1, endStep, pages);
        for (var i = start; i <= end; i++) {
            arr.push(i);
        }
        return arr;
    }, [page, pages, backStep, forwardStep]);
    var onPageChangeCreate = function (p) { return function () {
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(p);
    }; };
    var showLast = pages - page > backStep;
    var handleTextChange = function (_a) {
        var value = _a.target.value;
        var numericValue = Number(value);
        if (Number.isNaN(numericValue)) {
            return;
        }
        if (numericValue < 1) {
            // setPageText(1) // past value - из-за единицы появлялся баг
            setPageText(0);
        }
        else if (numericValue > pages) {
            setPageText(pages);
        }
        else {
            setPageText(numericValue);
        }
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(pageText);
    };
    // Отрисовка
    return (React.createElement(PaginationLayout, { isLoading: isLoading, disableOffset: props.disableOffset, button: showLoadMore && isCanLoadMore ? (React.createElement(Button.GreyLarge, { onClick: loadMore, style: { width: '100%', color: Colors.galBlack100 } }, t('show_more'))) : null, paging: pages > 1 && (React.createElement(React.Fragment, null,
            React.createElement(PaggingItemWrapper, { gx: 8 },
                page > forwardStep + 1 && (React.createElement(React.Fragment, null,
                    React.createElement(PageControl, { onClick: onPageChangeCreate(1), isBack: true }),
                    React.createElement(DotsContainer, null, "..."))),
                pagesList
                    .filter(function (i) {
                    if (showLast && page < pages - backStep - 1) {
                        return i !== (pagesList === null || pagesList === void 0 ? void 0 : pagesList.length);
                    }
                    return i;
                })
                    .map(function (value, index) { return (React.createElement("div", { key: "pi_".concat(value, "_ ").concat(index), className: 'pagging_item' }, value > 0 ? (React.createElement(PageNumber, { onClick: onPageChangeCreate(value), active: value === page }, value)) : null)); }),
                showLast && (React.createElement(React.Fragment, null, page < pages - backStep - 1 && (React.createElement(React.Fragment, null,
                    React.createElement(DotsContainer, null, "..."),
                    React.createElement(PageNumber, { onClick: onPageChangeCreate(pages), active: false }, pages))))),
                pagesList[forwardStep] > 0 && (React.createElement(PageControl, { onClick: onPageChangeCreate(page + 1), isNext: true }))),
            React.createElement(PageInputGroup, { onSubmit: handleSubmit },
                React.createElement(PageInputWrapper, null,
                    React.createElement(PageInput, { onChange: handleTextChange, value: pageText })),
                React.createElement(RectangularButtonHollow, { disabled: !pageText || pageText > pages, type: 'submit', style: { color: Colors.galBlack100, borderColor: Colors.galBlack31 } }, t('pagination.go_to_page'))))) }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=pagination.js.map